import React, { Component } from 'react'
import api from '~base/api'

import moment from 'moment'
import Page from '~base/page'
import Post from '~components/post'
import Loader from '~base/components/spinner'
import Link from '~base/router/link'

import tree from '~core/tree'

moment.locale('es')

class CommentForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      commentText: '',
      open: props.open
    }
  }

  handleTextChange (event) {
    this.setState({ commentText: event.target.value })
  }

  async handleSubmit (event) {
    event.preventDefault()

    var comment = {
      text: this.state.commentText,
      postUUID: this.props.post.uuid
    }

    if (this.props.parent) {
      comment.parentUUID = this.props.parent.uuid
    }

    var url = '/comparte/comments/'
    const newComment = await api.post(url, comment)

    this.setState({ commentText: '' })
    this.props.handleNewComment(newComment)
  }

  open () {
    this.setState({
      open: true
    })
  }

  render () {
    if (this.state.open) {
      return (
        <div className='comment-form'>
          <form onSubmit={(e) => this.handleSubmit(e)}>
            <div className='field'>
              <div className='control'>
                <textarea value={this.state.commentText} onChange={(e) => this.handleTextChange(e)} className='textarea' placeholder='Comentario' />
              </div>
            </div>
            <div className='field is-grouped'>
              <div className='control'>
                <input type='submit' value='Comentar' className='button is-primary' />
              </div>
            </div>
          </form>
        </div>
      )
    } else {
      return (
        <div onClick={() => this.open()} className='reply'>Responder <i className='fa fa-reply' /></div>
      )
    }
  }
}

class Comment extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    var childComments = []
    if (this.props.comments) {
      childComments = this.props.comments.filter(c => c.parent && c.parent.uuid === this.props.comment.uuid)
    }

    let commentForm
    if (tree.get('user')) {
      commentForm = <CommentForm post={this.props.post} parent={this.props.comment} handleNewComment={(c) => this.props.handleNewComment(c)} />
    }

    return (
      <div className='column is-12 comment'>
        <div className='box content'>
          <article className='post'>
            <a href='#'>@{this.props.comment.user.name}</a> lo posteo {moment.utc(this.props.comment.dateCreated).fromNow()}
            <p>{this.props.comment.text} </p>
            {childComments.map((comment) => <Comment key={comment.uuid} comment={comment} post={this.props.post} comments={this.props.comments} handleNewComment={(c) => this.props.handleNewComment(c)} />)}
            {commentForm}
          </article>
        </div>
      </div>
    )
  }
}

class PostDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      post: {}
    }
  }

  componentWillMount () {
    this.load()
  }

  async load () {
    var url = '/comparte/posts/' + this.props.match.params.uuid
    const body = await api.get(url)

    this.setState({
      loading: false,
      post: body.post,
      vote: body.vote,
      comments: body.comments
    })
  }

  addComment (comment) {
    this.setState({
      comments: this.state.comments.concat(comment)
    })
  }

  render () {
    const { post, vote } = this.state
    if (this.state.loading) {
      return <Loader />
    }

    const rootComments = this.state.comments.filter(x => typeof x.parent === 'undefined')

    let commentForm
    if (tree.get('user')) {
      commentForm = <CommentForm post={this.state.post} handleNewComment={(c) => this.addComment(c)} open />
    } else {
      commentForm = <div><Link to='/sign-up'>Regístrate</Link> o <Link to='/log-in'>entra</Link> para agregar un comentario</div>
    }

    return (
      <div className='column is-12'>
        <div className='box content'>
          <Post post={post} vote={vote} />
          {rootComments.map((comment) => <Comment key={comment.uuid} comment={comment} post={this.state.post} comments={this.state.comments} handleNewComment={(c) => this.addComment(c)} />)}
          {commentForm}
        </div>
      </div>
    )
  }
}

export default Page({
  path: '/posts/:uuid',
  title: 'Post details',
  exact: true,
  component: PostDetail
})



// WEBPACK FOOTER //
// ../frontend/pages/post/detail.js